import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageService, SessionStorageService } from 'angular-web-storage';
import { Observable } from 'rxjs';
import { Constants } from '../../shared/models/constants';
import { UserPersistenceService } from '../services/userPersistence.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private localStorageService: LocalStorageService, private sessionStorageService: SessionStorageService,
    private userPersistenceService: UserPersistenceService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.localStorageService.get(Constants.AUTH_TOKEN);

    // Get the auth header 
    const authHeader = 'bearer ' + token;

    // Do NOT set Content-Type for FormData requests — the browser must set it
    // automatically so it includes the multipart boundary. Overriding it here
    // would drop the boundary and break file uploads.
    const isFormData = req.body instanceof FormData;

    let headers = req.headers
      .set('Authorization', authHeader)
      .set('versionHomes', 'v2.1.0')
      .set('versionHospitality', 'v2.1.0')
      .set('versionOffices', 'v2.1.0')
      .set('versionEducation', 'v2.1.0')
      .set('versionRetail', 'v2.1.0')
      .set('versionHospitals', 'v2.1.0')
      .set('versionAllBuildings', this.userPersistenceService.selectedVersion3);

    if (!isFormData) {
      headers = headers.set('Content-Type', 'application/json');
    }

    const authReq = req.clone({ headers });

    return next.handle(authReq);
  }
}
